import React from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
  Switch,
} from "app/material-framework/materialComponents";
import { features } from "app/features";

export function ChatbotCheckboxes({ selectedOptions, setSelectedOptions, deepSearch, setDeepSearch }) {
  const eqEnabled = features.chatbot.showEqCheckbox === true;

  const handleChange = (option) => (event) => {
    const { checked } = event.target;

    if (option === "all") {
      if (!checked) {
        setSelectedOptions(
          eqEnabled
            ? { all: false, economics: false, fx: false, fi: false, eq: false }
            : { all: false, economics: false, fx: false, fi: false },
        );
        return;
      }
      setSelectedOptions(
        eqEnabled
          ? { all: true, economics: true, fx: true, fi: true, eq: true }
          : { all: true, economics: true, fx: true, fi: true },
      );
      return;
    }

    const newSelectedOptions = { ...selectedOptions, [option]: checked };
    const children = eqEnabled ? ["economics", "fx", "fi", "eq"] : ["economics", "fx", "fi"];
    const allChecked = children.every((key) => newSelectedOptions[key]);

    setSelectedOptions({ ...newSelectedOptions, all: allChecked });
  };

  const noneSelected = !(
    selectedOptions.all ||
    selectedOptions.economics ||
    selectedOptions.fx ||
    selectedOptions.fi ||
    (eqEnabled && selectedOptions.eq)
  );

  return (
    <Box
      sx={{
        borderBottom: 1,
        borderColor: "#D9D9D9",
        bgcolor: "#F5F5F5",
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          padding: "6px 14px",
          borderBottom: 1,
          borderColor: "#D9D9D9",
          fontWeight: 600,
          bgcolor: "#EFEFEF",
        }}
      >
        Asset class (select for more precise responses)
      </Typography>
      <Box sx={{ px: 2, pt: 1, pb: 1, overflowX: "auto" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            minWidth: 0,
          }}
        >
          <FormGroup row sx={{ flexWrap: "nowrap" }}>
            <FormControlLabel
              sx={{ marginRight: 1 }}
              control={
                <Checkbox size="small" checked={selectedOptions.all} onChange={handleChange("all")} name="all" />
              }
              label={<Typography sx={{ fontSize: "14px" }}>All</Typography>}
            />
            <FormControlLabel
              sx={{ marginRight: 1 }}
              control={
                <Checkbox
                  size="small"
                  checked={selectedOptions.economics}
                  onChange={handleChange("economics")}
                  name="economics"
                />
              }
              label={<Typography sx={{ fontSize: "14px" }}>Economics</Typography>}
            />
            <FormControlLabel
              sx={{ marginRight: 1 }}
              control={<Checkbox size="small" checked={selectedOptions.fx} onChange={handleChange("fx")} name="fx" />}
              label={<Typography sx={{ fontSize: "14px" }}>FX</Typography>}
            />
            <FormControlLabel
              sx={{ marginRight: 1 }}
              control={<Checkbox size="small" checked={selectedOptions.fi} onChange={handleChange("fi")} name="fi" />}
              label={<Typography sx={{ fontSize: "14px" }}>FI</Typography>}
            />
            {eqEnabled && (
              <FormControlLabel
                sx={{ marginRight: 1 }}
                control={<Checkbox size="small" checked={selectedOptions.eq} onChange={handleChange("eq")} name="eq" />}
                label={<Typography sx={{ fontSize: "14px" }}>EQ</Typography>}
              />
            )}
            <FormControlLabel
              sx={{ marginRight: 1 }}
              control={
                <Switch
                  checked={deepSearch}
                  onChange={(e) => setDeepSearch(e.target.checked)}
                  name="deepSearch"
                  color="primary"
                />
              }
              label={<Typography sx={{ fontSize: "14px" }}>Deep search</Typography>}
            />
            {/* todo add tool tip for deep search - sreesanth juhi required */}
          </FormGroup>
        </Box>
        {noneSelected && (
          <Box sx={{ pt: 0.5 }}>
            <Typography sx={{ fontSize: "12px", color: "#CA2420", pl: 0.5 }}>
              Select at least one asset class to proceed.
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}
